import baseScmService from 'services/baseScmService';

const blacklistService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getBlacklists: build.query({
      query: ({ filters, page = 1, pageLimit = 20 }) => {
        const { learnerEmail, superBatch } = filters;

        return {
          url: '/blacklists/',
          params: {
            'filters[user][email]': learnerEmail,
            'filters[user][super_batch]': superBatch?.value,
            page,
            page_limit: pageLimit,
          },
        };
      },
      providesTags: (result, error) => {
        if (error) return [];
        if (result?.data?.length > 0) {
          const response = result.data;

          return response.map((req) => ({
            type: 'Blacklist',
            id: req.id,
          }));
        }
        return [];
      },
    }),
    createBlacklist: build.mutation({
      query: (snoozeLearnerDetail) => ({
        method: 'POST',
        url: `/blacklists/`,
        body: {
          request_level: 'learner_level',
          learner_email: snoozeLearnerDetail.user_email,
          start_date: snoozeLearnerDetail.start_date,
          end_date: snoozeLearnerDetail.end_date,
        },
      }),
      invalidatesTags: (result, error, { requestId }) =>
        error ? [] : [{ type: 'Blacklist', id: requestId }],
    }),
    manageBlacklist: build.mutation({
      query: (snoozeLearnerDetail) => ({
        method: 'POST',
        url: `/blacklists/manage`,
        body: {
          request_level: 'learner_level',
          learner_email: snoozeLearnerDetail.user_email,
          start_date: snoozeLearnerDetail.start_date,
          end_date: snoozeLearnerDetail.end_date,
        },
      }),
      invalidatesTags: (result, error, { requestId }) =>
        error ? [] : [{ type: 'Blacklist', id: requestId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBlacklistsQuery,
  useCreateBlacklistMutation,
  useManageBlacklistMutation,
} = blacklistService;

export default blacklistService;
